import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import VolumeIcon from '../icons/Volume';
import Button from './Button';

import styles from '../../../styles/buttons/volume.module.scss';

const propTypes = {
    className: PropTypes.string,
    muted: PropTypes.bool,
    onClick: PropTypes.func,
};

const defaultProps = {
    className: null,
    muted: true,
    onClick: null,
};

const VolumeButton = ({ className, muted, onClick }) => (
    <Button
        onClick={onClick}
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <VolumeIcon muted={muted} />
    </Button>
);

VolumeButton.propTypes = propTypes;
VolumeButton.defaultProps = defaultProps;

export default VolumeButton;
